module.exports = __webpack_public_path__ + "6af0d79b97a2c704a1f34f97414b63dc.svg";